module.exports = __webpack_public_path__ + "img/icon_tips@2x.c28ab130.png";